export const invoiceLanguages = ['de', 'en', 'fi', 'fr', 'nl', 'sv'] as const
